import { getCurrentOrCustomerProfileSelect } from '../../selectors/get-current-or-customer'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import { updateAndValidateReduxAction } from '../../../../redux'

export function updateProfileAction (params) {
  return (dispatch, getState) => {
    const profile = getCurrentOrCustomerProfileSelect(getState())
    const { payload } = params
    const path = getPathReduxUtil(profile)

    dispatch(
      updateAndValidateReduxAction({
        type: params.type,
        payload: {
          instancePath: path,
          path,
          ...payload
        }
      })
    )

    // if (getCurrentCreatorClientIdSelect(getState())) {
    //   return
    // }
    //
    // const newProfile = getCurrentProfileSelect(getState())
    // setUserPropertiesAnalyticsUtil(newProfile)
  }
}
